(ns web3.hints.content
  (:require [web3.ui-state :as ui-state]
            [web3.i18n :as i]
            [web3.env :as env]))

(def hint-content
  {:hint/welcome.zip
   {:selector "#input-property-zip"
    :content [:span.weight-medium.text-size-16
              "Let's put your property on the map:"]
    :side :top}

   :hint/welcome.address
   {:selector "#StreetAddress_street1"
    :content (str "Complete your address for a richer " (:partner/name env/config) " experience. (Optional)")
    :side :bottom}

   :hint/home.global-add
   {:selector "#button-add-anything"
    :content (str "Start here to add anything to your " (:partner/name env/config) " property.")
    :side :left}

   :hint/add.anything.by-nameplate
   {:selector "#button-asset-by-nameplate"
    :content "Take a picture of a product label, and we'll look it up."
    :side :right}

   :hint/add.anything.by-form
   {:selector "#button-asset-by-form"
    :content #(if (ui-state/mobile?)
                "Let's start with what you have in front of you, your phone."
                "If you know the brand and model of your item, you can type it in here.")
    :side :right}

   :hint/add.anything.group
   {:selector "#button-add-group"
    :content "Group your things any way you like. Want to create a new group? Click here."
    :side :left}

   :hint/add.asset.what-is-this
   {:selector "#Asset_tagName"
    :content "Enter the type of item here (eg. \"phone\"). See a match? Select it."
    :side :bottom}

   :hint/add.asset.end-confirm.view-item
   {:selector "#link-end-confirm-view-item"
    :content "Well done! You’ve successfully added your item. Now click here to see it:"
    :side :bottom}

   :hints/group.suggested-item
   {:selector ".group-recommended-item"
    :content "Easily add items using these suggestions."
    :side :bottom}

   :hints/public.what-is-centriq
   {:selector "#what-is-centriq-i"
    :content (str (:partner/name env/config) " helps you with your home and everything in it."
                  "Fix it faster, use it better, and maintain it with ease with HomeServe."
                  "Sign up today! It's free and always will be! Click to learn more.")
    :side :right}
   :hints/asset.did-we-get-it-right
   {:selector "#did-we-get-it-right-info-bubble"
    :content "Is everything correct?  Let us know how we did, or just chat with us."
    :side :top}})

